const SqlParserUtil = require('../common/SqlParserUtil');
const Util = require('../common/Util');
const extend = require('../../../../base/util/Extend');
const SpatialOPUtil = require('../../../../utils/SpatialOPUtil');

let RUtil = {};
//
let resourceConfigCache = {};
let resourceMap = {};
const RESOURCE_SEPERATOR = '~';
const BUFFER_DISTANCE_SEPERATOR = '___';
//
RUtil.clear = function() {
    resourceConfigCache = {};
    resourceMap = {};
}

//
const handleResourceConfig = function(config, httpRequest, url) {
    return new Promise(async(resolve, reject) => {
        let resources = config.resources;
        //提取需要查询元数据的表
        let tableNames2Query = {};
        for (let tableId in resources) {
            let tableObj = resources[tableId];
            if (tableObj.table &&
                !(tableObj.selectField &&
                    Object.keys(tableObj.selectField).length > 0)) {
                tableNames2Query[tableObj.table] = tableNames2Query[tableObj.table] || [];
                tableNames2Query[tableObj.table].push(tableObj);
            }
            if (tableObj.children && Object.keys(tableObj.children).length > 0) {
                for (let childId in tableObj.children) {
                    let childrenObj = tableObj.children[childId];
                    if (childrenObj.table && !(
                            childrenObj.selectField &&
                            Object.keys(childrenObj.selectField).length > 0)) {
                        tableNames2Query[childrenObj.table] = tableNames2Query[childrenObj.table] || [];
                        tableNames2Query[childrenObj.table].push(childrenObj);
                    }
                }
            }
        }
        //默认查询所有字段
        if (Object.keys(tableNames2Query).length > 0) {
            let tableMetaCol = await Util.getMetas({
                url: url,
                httpRequest: httpRequest,
                tables: Object.keys(tableNames2Query)
            });
            for (let i = 0; i < tableMetaCol.length; i++) {
                let tableMeta = tableMetaCol[i];
                let fields = tableMeta.model;
                let selectField = {};
                for (let j = 0; j < fields.length; j++) {
                    selectField[fields[j].fieldName] = fields[j].fieldName;
                }
                let tableObjCol = tableNames2Query[tableMeta.dataSetId] || [];
                for (let j = 0; j < tableObjCol.length; j++) {
                    tableObjCol[j].selectField = selectField;
                }
            }
        }
        resolve(config);
    });
}

//
RUtil.getResourceConfig = function(httpRequest, configUrl, serverUrl, eventType) {
    return new Promise(async(resolve, reject) => {
        if (resourceConfigCache.hasOwnProperty(eventType)) {
            resolve(resourceConfigCache[eventType]);
        } else {
            configUrl = configUrl.replace(/\{eventType\}/g, eventType);
            let data = await httpRequest.get(configUrl, 'json');
            //处理数据
            let config = await handleResourceConfig(data, httpRequest, serverUrl);
            resourceConfigCache[eventType] = config;
            resolve(data);
        }
    });
}

//
RUtil.getResourceCatalog = function(httpRequest, configUrl, serverUrl, eventType) {
    return new Promise(async(resolve, reject) => {
        let catalog = [];
        let config = await this.getResourceConfig(httpRequest, configUrl, serverUrl, eventType);
        let resources = config.resources;
        for (let tableId in resources) {
            let tableObj = resources[tableId];
            let node = {};
            node.id = tableId;
            node.name = tableObj.title;
            node.parentId = null;
            catalog.push(node);
            //有子节点
            if (tableObj.children && Object.keys(tableObj.children).length > 0) {
                node.isLeaf = false;
                for (let childId in tableObj.children) {
                    let childrenObj = tableObj.children[childId];
                    let childNode = {};
                    childNode.id = [tableId, childId].join(RESOURCE_SEPERATOR);
                    childNode.name = childrenObj.title;
                    childNode.parentId = tableId;
                    childNode.isLeaf = true;
                    catalog.push(childNode);
                    //
                    let tempObj = extend(true, {}, tableObj);
                    delete tempObj.children;
                    for (let k in childrenObj) {
                        tempObj[k] = childrenObj[k];
                    }
                    // extend(true, tempObj, childrenObj);
                    resourceMap[childNode.id] = tempObj;
                }
            } else {
                resourceMap[node.id] = tableObj;
                node.isLeaf = true;
            }
        }
        resolve(catalog);
    });
}

//
RUtil.getResourceConfigById = function(resourceId) {
    return resourceMap[resourceId];
}


//
RUtil.makeBufferAggregates = function(opts) {
    let aggregateCol = [];
    let radiusCount = opts.radius.length;
    for (let i = 0; i < opts.resources.length; i++) {
        let resourceId = opts.resources[i];
        let resourceConfig = resourceMap[resourceId];
        let aggregateOpts = {};
        aggregateOpts.type = 'buffer';
        aggregateOpts.resourceId = resourceId;
        aggregateOpts.resourceConfig = resourceConfig;
        aggregateOpts.keyword = opts.keyword || null;
        aggregateOpts.radius = opts.radius[0];
        aggregateOpts.geometry = opts.geometry || null;
        aggregateOpts.spatialReference = opts.spatialReference || 4326;
        let aggregateObj = this.makeAggregate(aggregateOpts);
        for (let j = 0; j < radiusCount; j++) {
            let aggregateTmp = extend(true, {}, aggregateObj);
            aggregateTmp.searchId = aggregateTmp.searchId + BUFFER_DISTANCE_SEPERATOR + j;
            let geoNear = aggregateTmp.aggregate[0].$geoNear;
            geoNear.maxDistance = opts.radius[j];
            if (j > 0) {
                geoNear.minDistance = opts.radius[j - 1];
            }
            aggregateCol.push(aggregateTmp);
        }
    }
    return aggregateCol;
}

//
RUtil.makeAggregates = function(opts, type) {
    let aggregateCol = [];
    for (let i = 0; i < opts.resources.length; i++) {
        let resourceId = opts.resources[i];
        let resourceConfig = RUtil.getResourceConfigById(resourceId);
        if (resourceConfig) {
            let aggregateOpts = {};
            aggregateOpts.type = type;
            aggregateOpts.resourceId = resourceId;
            aggregateOpts.resourceConfig = resourceConfig;
            aggregateOpts.keyword = opts.keyword || null;
            aggregateOpts.districtCode = opts.districtCode || null;
            aggregateOpts.geometry = opts.geometry || null;
            aggregateOpts.geometryFilter = opts.geometryFilter || null;
            aggregateOpts.spatialReference = opts.spatialReference || 4326;
            let aggregateObj = this.makeAggregate(aggregateOpts);
            aggregateCol.push(aggregateObj);
        }
    }
    return aggregateCol;
}


//
RUtil.parseBufferQueryResult = function(result, radiusList, resourceIds) {
    let resultCollectionArray = [];
    for (let i = 0; i < radiusList.length; i++) {
        let resultCollection = {
            total: 0,
            radius: radiusList[i],
            collection: []
        };
        for (let j = 0; j < resourceIds.length; j++) {
            let resourceId = resourceIds[j];
            let resourceConfig = RUtil.getResourceConfigById(resourceId);
            if (resourceConfig) {
                let resultKey = resourceId + BUFFER_DISTANCE_SEPERATOR + i;
                let resourceData = result[resultKey];
                let collection = {};
                collection.id = resourceId;
                collection.name = resourceConfig.title;
                collection.list = resourceData[resourceConfig.table];
                resultCollection.total += collection.list.length;
                resultCollection.collection.push(collection);
            }
        }
        resultCollectionArray.push(resultCollection);
    }
    return resultCollectionArray;
}


//
RUtil.parseQueryResult = function(result, resourceIds) {
    let resultCollection = {
        total: 0,
        collection: []
    };
    for (let j = 0; j < resourceIds.length; j++) {
        let resourceId = resourceIds[j];
        let resourceConfig = RUtil.getResourceConfigById(resourceId);
        let resourceData = result[resourceId];
        let collection = {};
        collection.id = resourceId;
        collection.name = resourceConfig.title;
        collection.list = resourceData[resourceConfig.table];
        resultCollection.total += collection.list.length;
        resultCollection.collection.push(collection);
    }
    return resultCollection;
}



/** 
 * 单个资源管道
 * @param opts
 * @param opts.type {String} 查询类型 buffer/keyword/district/polygon
 * @param opts.resourceId {String}
 * @param opts.resourceConfig {Object}
 * @param [opts.limit] {Integer}
 * @param [opts.keyword] {String}
 * @param [opts.districtCode] {String[]}
 * @param [opts.radius] {Number}
 * @param [opts.geometry] {GeoJSON}
 * @param [opts.geometryFilter] {GeoJSON}
 * @param [opts.spatialReference] {Integer}
 * 
 */
RUtil.makeAggregate = function(opts) {
    let aggregateObj = {},
        aggregate = [];
    let tableName = opts.resourceConfig.table;
    aggregateObj.query = {};
    aggregateObj.searchId = opts.resourceId;
    aggregateObj.dataSetId = tableName;
    aggregateObj.queryIndex = 0;
    let relationTableAlias = {};
    //filter
    let matchObj = this.queryBuilders.buildMatch(opts, relationTableAlias);
    //geoNear
    let geoNear = RUtil.queryBuilders.buildGeoNear(opts);
    if (geoNear) { //点缓冲
        if (matchObj.inGeoNear.$and.length > 0) {
            geoNear.$geoNear.query = matchObj.inGeoNear;
        }
        aggregate.push(geoNear);
        aggregateObj.queryIndex = 1;
        //
        if (matchObj.postGeoNear && matchObj.postGeoNear.$and.length > 0) {
            aggregateObj.query = matchObj.postGeoNear;
        }
    } else {
        let matchAnd = [];
        if (matchObj.inGeoNear && matchObj.inGeoNear.$and.length > 0) {
            matchAnd = matchAnd.concat(matchObj.inGeoNear.$and);
        }
        //
        if (matchObj.postGeoNear && matchObj.postGeoNear.$and.length > 0) {
            matchAnd = matchAnd.concat(matchObj.postGeoNear.$and);
        }
        if (matchAnd.length > 0) {
            aggregateObj.query = {
                '$and': matchAnd
            };
        }
        //处理查询
        if (opts.geometry && opts.radius) {
            opts.geometryFilter = opts.geometryFilter || SpatialOPUtil.getBuffer({
                geometry: opts.geometry,
                radius: opts.radius,
                spatialReference: opts.spatialReference
            });
        }
    }
    //select
    let selectObj = RUtil.queryBuilders.buildSelect(opts, relationTableAlias);
    //sort
    let sortObj = RUtil.queryBuilders.buildSort(opts, relationTableAlias);
    //
    //
    if (Object.keys(relationTableAlias).length > 0) {
        let relationObj = RUtil.queryBuilders.buildRelation(opts, relationTableAlias);
        //project
        let project = extend(true, {}, selectObj.preLookup);
        extend(true, project, relationObj.project || {});
        extend(true, project, matchObj.preLookupSelect || {});
        aggregate.push({
            '$project': project
        });
        //loolup
        aggregate = aggregate.concat(relationObj.aggregate);
        //filter
        if (matchObj.postLookup.$and.length > 0) {
            aggregate.push({
                '$match': {
                    '$and': matchObj.postLookup.$and
                }
            });
        }
        //project
        if (Object.keys(selectObj.postLookup).length > 0) {
            aggregate.push({
                '$project': selectObj.postLookup
            });
        }
    } else {
        aggregate.push({
            '$project': selectObj.preLookup
        });
    }
    if (Object.keys(sortObj.preLookup).length > 0) {
        aggregate.push({
            '$sort': sortObj.preLookup
        });
    }
    if (opts.limit) {
        aggregate.push({
            '$limit': opts.limit
        });
    }
    aggregateObj.aggregate = aggregate;
    //
    console.debug(aggregateObj)
    return aggregateObj;
}

//builders
RUtil.queryBuilders = {
    //
    buildGeoNear(opts) {
        if (!(opts.geometry && opts.geometry.type == 'Point')) {
            return null;
        }
        let geoNear = {};
        geoNear.limit = 1000 * 1000;
        geoNear.maxDistance = opts.radius ? parseFloat(opts.radius) : 5000 * 1000;
        geoNear.minDistance = 0;
        geoNear.spherical = true;
        geoNear.near = opts.geometry;
        geoNear.includeLocs = "geom";
        geoNear.distanceField = "distance";
        return {
            $geoNear: geoNear
        };
    },
    //
    buildMatch(opts, relationTableAlias) {
        let matchObj = {
            inGeoNear: {
                $and: []
            },
            postGeoNear: {
                $and: []
            },
            postLookup: {
                $and: []
            },
            //处理过滤字段不在查询字段的情况
            preLookupSelect: {}
        }
        if (opts.resourceConfig.filter) {
            let parseWhere = SqlParserUtil.parseSqlFragment('where', opts.resourceConfig.filter);
            let query = SqlParserUtil.translateWhere(parseWhere);
            matchObj.inGeoNear.$and.push(query);
        }
        //
        if (opts.districtCode && opts.districtCode.length > 0) {
            let queryDistrict = {};
            queryDistrict['tag.' + opts.resourceConfig.districtField] = {
                '$in': opts.districtCode
            }
            matchObj.inGeoNear.$and.push(queryDistrict);
        }
        //
        if (opts.keyword) {
            let keywordFields = opts.resourceConfig.keywordFields;
            if (keywordFields && keywordFields.length > 0) {
                let keywordRegex = {
                    '$regex': '^.*' + opts.keyword + '.*$'
                };
                let keywordOr = [
                    [], //pre
                    [], //post
                    [], //post&pre
                ];
                for (let i = 0; i < keywordFields.length; i++) {
                    let keywordField = keywordFields[i];
                    let keywordFieldFragments = keywordField.split('.');
                    if (keywordFieldFragments.length == 2) {
                        let query = {};
                        let fieldKey = [keywordFieldFragments[0], 'tag', keywordFieldFragments[1]].join('.');
                        query[fieldKey] = keywordRegex;
                        keywordOr[1].push(query);
                        //
                        relationTableAlias[keywordFieldFragments[0]] = true;
                    } else {
                        let query = {};
                        query['tag.' + keywordField] = keywordRegex;
                        keywordOr[0].push(query);
                        //
                        let isSelected = false;
                        for (let field in opts.resourceConfig.selectField) {
                            if (opts.resourceConfig.selectField[field] == keywordField) {
                                let query1 = {};
                                query1[field] = keywordRegex;
                                keywordOr[2].push(query1);
                                isSelected = true;
                                break;
                            }
                        }
                        if (!isSelected) { //过滤字段不在查询字段里
                            matchObj.preLookupSelect[keywordField] = '$tag.' + keywordField;
                        }
                    }
                }
                if (keywordOr[1].length > 0) {
                    matchObj.postLookup.$and.push({
                        '$or': keywordOr[2].concat(keywordOr[1])
                    });
                } else {
                    matchObj.inGeoNear.$and.push({
                        '$or': keywordOr[0]
                    });
                }
            }
        }
        //
        if (opts.geometryFilter) {
            matchObj.postGeoNear.$and.push({
                "geom": {
                    '$geoIntersects': {
                        '$geometry': opts.geometryFilter
                    }
                }
            });
        }
        return matchObj;
    },
    buildSelect(opts, relationTableAlias) {
        let selectObj = {
            preLookup: {
                id: '$_id',
                geometry: '$geom',
                //距离精确到米
                distance: {
                    '$floor': '$distance'
                },
                _id: false
            },
            postLookup: {}
        };
        let selectField = opts.resourceConfig.selectField;
        for (let field in selectField) {
            if (field.indexOf('//') == 0) {
                continue;
            }
            let fieldFragments = selectField[field].split('.');
            if (fieldFragments.length == 2) {
                selectObj.postLookup[field] = '$' + [fieldFragments[0], 'tag', fieldFragments[1]].join('.');
                relationTableAlias[fieldFragments[0]] = true;
            } else {
                if (selectField[field] == 'geom') {
                    selectObj.preLookup[field] = '$' + selectField[field];
                } else {
                    selectObj.preLookup[field] = '$tag.' + selectField[field];
                }
            }
        }
        for (let field in selectObj.preLookup) {
            selectObj.postLookup[field] = '$' + field;
        }
        return selectObj;
    },
    buildSort(opts, relationTableAlias) {
        let sortObj = {
            preLookup: {},
            postLookup: {}
        };
        let parseSort = SqlParserUtil.parseSqlFragment('sort', opts.resourceConfig.sort);
        for (let i = 0; i < parseSort.length; i++) {
            let sortItem = parseSort[i];
            sortObj.preLookup[sortItem.expr.column] = sortItem.type == 'ASC' ? 1 : -1;
        }
        return sortObj;
    },
    buildRelation(opts, relationTableAlias) {
        let relationObj = {};
        relationObj.aggregate = [];
        relationObj.project = {};
        for (let i = 0; i < opts.resourceConfig.relateTables.length; i++) {
            let relationTable = opts.resourceConfig.relateTables[i];
            if (relationTableAlias.hasOwnProperty(relationTable.alias)) {
                let lookup = {};
                lookup.from = 'user_safety_' + relationTable.table;
                lookup.localField = 'tag.' + relationTable.localField;
                lookup.foreignField = 'tag.' + relationTable.foreignField;
                lookup.as = relationTable.alias;
                relationObj.aggregate.push({
                    '$lookup': lookup
                });
                relationObj.aggregate.push({
                    '$unwind': {
                        "path": "$" + relationTable.alias,
                        "preserveNullAndEmptyArrays": true
                    }
                });
                relationObj.project[lookup.localField] = '$' + lookup.localField;
            }
        }
        return relationObj;
    }
}

module.exports = RUtil;
//